import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Stories from "./Stories";

const ProductListTestimonials = ({ data }) => {
  const { testimonials } = data !== undefined && data;
  if (!testimonials?.length > 0) {
    return;
  }
  return (
    data && (
      <div className="md:mt-[3vw] mt-[12vw] md:w-[85%] xs:w-[95%] m-auto">
        <Header headingData={testimonials?.[0]} />
        <Stories storiesData={testimonials} />
      </div>
    )
  );
};

ProductListTestimonials.propTypes = {
  data: PropTypes.object,
};

export default ProductListTestimonials;
